import { gtmApiHelper } from "../gtm/gtm-api-helper";

export async function useSubmitContactFormEffect() {
  await gtmApiHelper.submit_contact_form();
}